import { render, staticRenderFns } from "./Companies.vue?vue&type=template&id=75b714a8&lang=pug&"
import script from "./Companies.vue?vue&type=script&lang=ts&"
export * from "./Companies.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports